module.exports = __webpack_public_path__ + "img/media-12.d545aa5e.png";